import { IMAGE_URL } from "../../config/axios";

const getInitials = (name) => {
  if (!name) return '';
  const nameArray = name.split(" ");
  return nameArray.length > 1
    ? nameArray[0][0]?.toUpperCase() + nameArray[1][0]?.toUpperCase()
    : nameArray[0][0]?.toUpperCase();
};

const getRandomColor = (name) => {
  const colorPairs = [
    { light: "#fbbfc8ff", dark: "#C71585" }, // Light pink and dark pink
    { light: "#f996c7ff", dark: "#C71585" }, // Light hot pink and dark pink
    { light: "#f598c9ff", dark: "#8B008B" }, // Deep pink and dark magenta
    { light: "#fa9b8bff", dark: "#B22222" }, // Light red-orange and dark red
    { light: "#fcc1abff", dark: "#8B0000" }, // Orange-red and dark red
    { light: "#FF8C00", dark: "#d55e09ff" }, // Dark orange and chocolate
    { light: "#f6eea3ff", dark: "#978e12ff" }, // Khaki and dark khaki
    { light: "#a7e4f8ff", dark: "#1E90FF" }, // Light sky blue and dark blue
    { light: "#8abfeaff", dark: "#2F4F4F" }, // Steel blue and dark slate gray
    { light: "#aaf2aaff", dark: "#006400" }, // Light green and dark green
    { light: "#b8f7dfff", dark: "#228B22" }, // Medium spring green and forest green
    { light: "#f8edabff", dark: "#FF8C00" }, // Light gold and dark orange
    { light: "#FFDDC1", dark: "#D2691E" }, // Peach and chocolate
    { light: "#d1a7f9ff", dark: "#4B0082" }, // Blue-violet and indigo
    { light: "rgb(210 162 234)", dark: "#8B008B" }, // Dark orchid and dark magenta
    { light: "#fbb6e2ff", dark: "#8B0000" }, // Medium violet red and dark red
    { light: "#C0C0C0", dark: "#808080" }, // Silver and gray
    { light: "#A9A9A9", dark: "#696969" }, // Dark gray and dim gray
    { light: "#dd9561ff", dark: "#2F4F4F" }, // Saddle brown and dark slate gray
    { light: "#FFA500", dark: "#FF4500" }, // Orange and orange-red
    { light: "#f78bc4ff", dark: "#a70566ff" }, // Deep pink and dark magenta
    { light: "#f9dcdcff", dark: "#A9A9A9" }, // Light gray and dark gray
    { light: "#E0FFFF", dark: "#00CED1" }, // Light cyan and dark turquoise
    { light: "#F5FFFA", dark: "#2F4F4F" }, // Mint cream and dark slate gray
    { light: "#c6f97aff", dark: "#006400" }, // Green yellow and dark green
    { light: "#b5f9f9ff", dark: "#008B8B" }, // Aqua and dark cyan
    { light: "#9befebff", dark: "#008B8B" }, // Light sea green and dark cyan
    { light: "#b4e3f6ff", dark: "#4682B4" }, // Sky blue and steel blue
    { light: "#FFFFE0", dark: "#BDB76B" }, // Light yellow and dark khaki
  ];

  const index = name.charCodeAt(0) % colorPairs.length;
  return colorPairs[index];
};

const UserDefaultLogo = ({ user, customStyleforParent, customStyleforChild }) => {
  if (!user) {
    const randomColor = getRandomColor("default");
    return (
      <div
        className="circle"
        style={{ backgroundColor: randomColor.light }}
      ></div>
    );
  }

  const hasProfilePic = user?.profilepic;
  const initials = getInitials(user?.name || '');
  const { light: backgroundColor, dark: textColor } = getRandomColor(user.name || "#f6f7f9");

  return (
    <div className={`${customStyleforParent}`}>

      {hasProfilePic ? (
        <img
          src={`${IMAGE_URL}${user.profilepic}`}
          alt={user.name || 'User'}
          className={`${customStyleforChild} circle`}
          style={{ borderRadius: '50%', objectFit: 'cover', width: '100%', height: '100%' }}
        />
      ) : (
        <div
          className={`${customStyleforChild} circle`}
          style={{
            backgroundColor: backgroundColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: textColor,
            height: '100%',
            width: '100%'
          }}
        >
          {initials}
        </div>
      )}
    </div>
  );
};

export default UserDefaultLogo;
export { getRandomColor };









